import React, { FC, useEffect, useMemo, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import * as csv from "csvtojson";
import { Parser } from "json2csv";

import { DistrictUtil, useAsync } from "../../../utils";
import {
	getInventoryInPharmacy,
	getPharmacyInfoLocal,
	ISearchEsProduct,
	searchInventory,
} from "../../../api";
import { InventoryModel, PharmacyModel } from "../../../models";
import { SearchPharmacys } from "../../Pharmacys";
import { accountDataState } from "../../../recoil/account";
import { useRecoilValue } from "recoil";

enum outputHeadersEnum {
	no = "STT",
	name = "Tên sản phẩm",
	medigoId = "ID sản phẩm",
	category = "Phân nhóm",
	pkgName = "Loại đóng gói",
	pkgPrice = "Giá",
    pkgOriginPrice = "Giá gốc",
	stock = "Tồn kho",
	isDropShipping = "Sản phẩm chạy hàng",
	pharmacies = "Nơi chạy hàng"
}

const InventoryDownload: FC = () => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [loadingPercent, setLoadingPercent] = useState<number>(0);

	const [isSuccess, setIsSuccess] = useState<boolean>(false);
	const [csvInfo, setCsvInfo] = useState<{
		headers: string[];
		rows: any[];
		errors: string[];
	}>({
		headers: [],
		rows: [],
		errors: [],
	});
	const [outRows, setOutRows] = useState<any[]>([]);

	// const searchInventoryAsync = useAsync(searchInventory);
	const getInventoryInPharmacyAsync = useAsync(getInventoryInPharmacy);

	const pharmacyInfo = getPharmacyInfoLocal();
	const [selectedPharmacy, setSelectedPharmacy] =
		useState<PharmacyModel | null>(
			pharmacyInfo?.pharmacyData ? pharmacyInfo.pharmacyData : null
		);
	const accountInfo = useRecoilValue(accountDataState);

	const adminId = useMemo(() => {
		if (accountInfo.loginSession.userLocalType == "ADMIN")
			return accountInfo.doctor.mId;
	}, [accountInfo]);

	const handleSelectPharmacy = (selectedPharmacy: PharmacyModel) => {
		setSelectedPharmacy(selectedPharmacy);
	};

	const getQuery = (pharId: number) => {
		return {
			from: 0,
			size: 10000,
			query: {
				bool: {
					filter: [
						{
							match: {
								mPharmacyId: pharId,
							},
						},
					],
				},
			},
		};
	};

	const handleSeach = async (pharmacyId: number) => {
		try {
			let res = await getInventoryInPharmacyAsync.execute({
				adminId,
				pharmacyId,
                filter: {
                    where: {}
                }
			});
			console.log("res.data: ", res.listInventory);
			return res.listInventory;
		} catch (err) {
			console.log("error: ", err);
		}
	};

	const onDownloadClick = async () => {
		if (isLoading) {
			return;
		}

		setIsLoading(true);

		let outRows: any[] = [];

		let inventoryItems: InventoryModel[] = await handleSeach(
			parseInt(selectedPharmacy?.mId || "0")
		);

		console.log("inventoryItems: ", inventoryItems);

		if (inventoryItems) {
			let totalItems = inventoryItems.length;

			for (let i = 0; i < totalItems; ++i) {
				let row: any = {};

				const item = inventoryItems[i];

				row[outputHeadersEnum.no] = i + 1;
				row[outputHeadersEnum.name] = item.mProductName;
				row[outputHeadersEnum.medigoId] = item.mProductId;
				row[outputHeadersEnum.category] = item.mCategory;
                row[outputHeadersEnum.pkgName] = item.mPkgName;
                row[outputHeadersEnum.pkgPrice] = item.mPrice;
                row[outputHeadersEnum.pkgOriginPrice] = item.mOriginalPrice;
                row[outputHeadersEnum.stock] = item.mInStock ? "Còn hàng" : "Hết hàng";
				row[outputHeadersEnum.isDropShipping] = item.mIsDropShipping ? "Chạy hàng" : "Có sẵn";
				row[outputHeadersEnum.pharmacies] = item.dropshippingPhars;

				outRows.push(Object.assign({}, row));

				setLoadingPercent(Math.floor(((i + 1) * 100) / totalItems));
			}
		}

		console.log("rows: ", outRows);
		setOutRows(outRows);

		setIsLoading(false);
		setIsSuccess(true);
	};

	const replaceString = (str: string, value: string): string => {
		return str.replace("{replaceMe}", value);
	};

	const getDisableClass = () => {
		if (isLoading || csvInfo.errors.length > 0 || !selectedPharmacy) {
			return "disabled";
		}

		return "";
	};

	const downloadFile = () => {
		let parser = new Parser();
		let csv = parser.parse(outRows);

		var blob = new Blob([csv], { type: "text/csv;charset=utf8;" });

		var uri = "data:attachment/csv;charset=utf-8," + encodeURI(csv);
		var link = document.createElement("a");
		link.href = URL.createObjectURL(blob);
		link.setAttribute("visibility", "hidden");
		// link.download = selectedFile.name;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<div>
			<LoadingOverlay
				active={isLoading}
				spinner
				text={"Đang xử lý ... " + loadingPercent + "%"}
				fadeSpeed={500}
			>
				{isLoading ? <div className="overlay-wrapper"></div> : ""}
			</LoadingOverlay>
			<SearchPharmacys handleSelect={handleSelectPharmacy} />
			<div className="management-content">
				<div className="row mt-3 mb-4 align-items-center">
					<div className="col-auto">Nhà thuốc</div>
					<div className="col-auto ml-auto">
						{selectedPharmacy ? selectedPharmacy.mName : "Chưa có"}
					</div>
				</div>
			</div>

			{isSuccess && outRows.length > 0 ? (
				<div className="text-center mt-5 text-success">
					Xử lý dữ liệu thành công
					<button className="btn m-3 px-3" onClick={downloadFile}>
						Tải file
					</button>
				</div>
			) : (
				""
			)}

			{isSuccess && outRows.length == 0 ? (
				<div className="text-center mt-5 text-success">
					Không có dữ liệu của nhà thuốc
				</div>
			) : (
				""
			)}

			<div className="fixed-button">
				<a
					onClick={(e) => {
						e.preventDefault();
						onDownloadClick();
					}}
					className={`btn btn-block ${getDisableClass()}`}
					href="/#"
				>
					XỬ LÝ DỮ LIỆU
				</a>
			</div>
		</div>
	);
};

export default InventoryDownload;
